export default __webpack_public_path__ + "static/media/client15.644a3de9.png";